import React from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import CreatableSelect from 'react-select/creatable';

const ChipsFilter = ({
	allItems,
	title,
	onSetSelectedItem,
	type,
	loadOptions,
	handleInputChange,
	selectedValue,
	onTotalPercentage
}) => {
	const onSelectItem = (selected) => {
		if (onTotalPercentage) {
			onTotalPercentage(selected);
		}
		onSetSelectedItem(selected);
	};

	const styles = {
		control: (base) => ({
			...base,
			fontFamily: 'Inter',
			fontSize: '14px'
		}),
		menu: (base) => ({
			...base,
			fontFamily: 'Inter',
			fontSize: '14px'
		})
	};

	return (
		<div className="form-group no-shadow-react-select size36">
			{type === 'ASYNC' ? (
				<AsyncSelect
					styles={styles}
					defaultOptions
					isMulti
					value={selectedValue}
					// getOptionLabel={(e) => e.label}
					// getOptionValue={(e) => e.value}
					loadOptions={loadOptions}
					onInputChange={handleInputChange}
					onChange={onSelectItem}
					placeholder={title}
					isOptionDisabled={(option) => option.isDisable}
				/>
			) : type === 'CREATABLE' ? (
				<CreatableSelect
					styles={styles}
					// value={selectedStrengthList}
					isMulti
					onChange={onSelectItem}
					options={allItems}
					placeholder={title}
					isSearchable={true}
					closeMenuOnSelect={false}
				/>
			) : (
				<Select
					styles={styles}
					options={allItems}
					isClearable
					isMulti
					onChange={onSelectItem}
					closeMenuOnSelect={false}
					placeholder={title}
					isSearchable={true}
				/>
			)}
		</div>
	);
};

export default ChipsFilter;
